// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cY9wfZSmVYEIgv3OeyCn{flex-shrink:0;margin-left:auto}`, "",{"version":3,"sources":["webpack://./services/client/src/components/Stepper/components/StepperItemContent/styles.module.scss"],"names":[],"mappings":"AAEA,sBACE,aAAA,CACA,gBAAA","sourcesContent":["@import '../../../../styles/global.scss';\n\n.check-icon {\n  flex-shrink: 0;\n  margin-left: auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"check-icon": `cY9wfZSmVYEIgv3OeyCn`
};
export default ___CSS_LOADER_EXPORT___;
